export const Images = {
  //header
  appStore: require("./app-store.svg").default,
  checkedLogo: require("./checked.svg").default,
  loginLogo: require("./login-logo.svg").default,
  mainLogo: require("./main-logo.svg").default,
  playStore: require("./play-store.svg").default,
  bgImage: require("./bg-image.png").default,

  //candidate landing page
  addJobIcon: require("./add-job-icon.png").default,
  instituteLogo: require("./institutes-logo.svg").default,
  jobsLogo: require("./jobs-logo.svg").default,
  nearBy: require("./near-bu.svg").default,
  orangeRightLogo: require("./orange-right-arrow.svg").default,
  penLogo: require("./pen.svg").default,
  stopWatchLogo: require("./stop-watch.svg").default,
  arrowDown: require("./arrow-down.svg").default,

  profileSearch: require("./profile-search.svg").default,
  applyJob: require("./apply-job.svg").default,
  suitcaseLogo: require("./suitcase.svg").default,

  dotsLow: require("./dots-low.svg").default,
  dotsUp: require("./dots-up.svg").default,
  careerChoice: require("./career-choice.svg").default,
  flag: require("./flag.svg").default,

  resume: require("./resume.svg").default,
  support: require("./support.svg").default,
  dotsLeftBottom: require("./dots-left-bottom.svg").default,

  menTree: require("./men-tree.svg").default,
  threeRed: require("./three-red.svg").default,
  violetTriangle: require("./violet-triangle.svg").default,
  mLogo: require("./m-logo.svg").default,
  purpleSpiral: require("./purple-spiral.svg").default,
  tetrisSilver: require("./tetris-silver.svg").default,
  greenSpinner: require("./green-spinner.svg").default,
  blueHexagon: require("./blue-hexagon.svg").default,
  phoneHand: require("./phone-in-hand.png").default,
  appStoreDark: require("./app-store dark.svg").default,

  schoolOne: require("./school-one.png").default,
  schoolTwo: require("./school-two.png").default,
  schoolThree: require("./school-three.png").default,
  schoolFour: require("./school-four.png").default,

  blackSuitCase: require("./black-suitcase-logo.svg").default,
  locationLogo: require("./location.svg").default,
  bookLogo: require("./book-logo.svg").default,
  stopWatch: require("./stop-watch.svg").default,
  topRightDots: require("./top-right-dots.svg").default,

  //login
  linkedLogo: require("./linkedin.svg").default,
  facebook: require("./facebook.svg").default,
  google: require("./google.svg").default,
  grayHand: require("./gray-hand.svg").default,
  graySuitcase: require("./gray-suitcase.svg").default,
  grayWatch: require("./gray-watch.svg").default,

  upDown: require("./up-down.svg").default,

  uploadLogo: require("./cloud.svg").default,

  letterInBox: require("./letter-in-box.svg").default,
  interviewLogo: require("./interview.svg").default,
  cvLogo: require("./cv-logo.svg").default,
  blueCorrect: require("./blue-correct.svg").default,
  manWIthStars: require("./man-with-stars.svg").default,
  groupLogo: require("./group-logo.svg").default,
  blueGroup: require("./blue-group.svg").default,
  checkLogo: require("./check-logo.svg").default,
  webIcon: require("./web-icon.svg").default,
  listIcon: require("./list-icon.svg").default,
  bellIcon: require("./bell-icon.svg").default,
  searchIcon: require("./search-icon.svg").default,
  blueBook: require("./blue-book.svg").default,
  blueLocation: require("./blue-location.svg").default,

  starBorder: require("./star-border.svg").default,

  eyeLogo: require("./eyes.svg").default,
  shareLogo: require("./share.svg").default,

  watchFilled: require("./watch-filled.svg").default,

  addIcon: require("./add-icon.svg").default,
  penIcon: require("./pen-icon.svg").default,
  blueCamera: require("./blue-camera.svg").default,
  callLogo: require("./call-logo.svg").default,
  userLogo: require("./user.svg").default,
  email: require("./email.svg").default,
  moneyLogo: require("./money-logo.svg").default,

  graySearch: require("./search-gray.svg").default,

  cvBorderLogo: require("./cv-border.svg").default,
  penPage: require("./page-pen.svg").default,
  pencilIcon: require("./pencil-icon.svg").default,

  blueBox: require("./blue-box.svg").default,
  manWithCV: require("./man-with-cv.svg").default,
  lady: require("./lady.svg").default,
  zoomPeople: require("./zoom-people.svg").default,
  goldMedal: require("./gold-medal.svg").default,
  stocks: require("./stonks.svg").default,
  moneyEnvelope: require("./money-envelope.svg").default,
  virtualHR: require("./virtual-hr.svg").default,
  infoLogo: require("./info-logo.svg").default,
  hiredLogo: require("./hired-logo.svg").default,
  resumeZoom: require("./resume-zoom.svg").default,

  checkedLogoNew: require("./checked-logo.svg").default,
  orangeBox: require("./orange-box.svg").default,
  greenBox: require("./green-box.svg").default,
  darkLogo: require("./dart.svg").default,
  manLogo: require("./man.svg").default,
  docBag: require("./doc-bag.svg").default,
  jobPostLogo: require("./job-post-logo.svg").default,
  smartMatch: require("./smart-match.svg").default,

  facebookWhiteLogo: require("./facebook-white.svg").default,
  twitterWhite: require("./Twitter.svg").default,
  googlePlusWhite: require("./G+.svg").default,
  linkedInLogo: require("./Linkedin-white.svg").default,
  appStoreFull: require("./apstore-full.svg").default,
  gplayStoreFull: require("./gp-play-full.svg").default,
  blueDotsTopLeft: require("./blue-dots-top-left.svg").default,
  blueDotsBottomRight: require("./blue-dots-bottom-right.svg").default,

  success: require("./success.svg").default,
  whiteTriangle: require("./white-triangle.svg").default,
  ladyWalking: require("./lady-walking.png").default,
  techSupport: require("./tech-support.png").default,
  starFilled: require("./star-filled.svg").default,
  dotsGrayBottomLeft: require("./dots-gray-bottom-left.svg").default,
  dotsGrayTopRight: require("./dots-gray-top-right.svg").default,
  relaxing: require("./relaxing.svg").default,

  noSkills: require("./no-skills.svg").default,
  noSettings: require("./no-settings.svg").default,
  graduationCap: require("./graduation-cap.svg").default,
  noSuitCase: require("./no-suitcase.svg").default,

  commas: require("./commas.svg").default,
  commasInverted: require("./commas-inverted.svg").default,

  grayRay: require("./gray-ray.svg").default,

  orangeRay: require("./orange-ray.svg").default,

  acadsApp: require("./acads-app.jpeg").default,
  vedantuMain: require("./vedantu.jpeg").default,

  vedantuLogo: require("./vedantu-login.jpeg").default,

  cvMan: require("./cv-man.jpeg").default,
  blueApple: require("./blue-apple.svg").default,

  whiteHat: require("./white-hat.png").default,
  unacademy: require("./unacademy.png").default,
  ada: require("./ada.png").default,
  vedantu: require("./vedantu.png").default,
  pearson: require("./pearson.png").default,
  tcis: require("./tcis.png").default,
  dyPatil: require("./dy-patil.png").default,
  inventure: require("./inventure.jpg").default,
  jsw: require("./jsw.jpg").default,

  blueComments: require("./blue-comments.svg").default,
  employees: require("./employees.png").default,

  human: require("./human.svg").default,
  meeting: require("./meeting.jpg").default,

  bcOne: require("./bc-first.svg").default,
  bcTwo: require("./bc-second.svg").default,
  bcThree: require("./bc-third.svg").default,
  bcFour: require("./bc-four.svg").default,
  bcFive: require("./bc-five.svg").default,
  bcSix: require("./bc-six.svg").default,

  clientOne: require("./clientOne.jpg").default,
  clientTwo: require("./clinetTwo.jpg").default,
  clientThree: require("./clientThree.png").default,
  clientFour: require("./clientFour.jpg").default,
  clientFive: require("./clientFive.png").default,
  clientSix: require("./clientSix.png").default,
  clientSeven: require("./clientSeven.png").default,
  clientEight: require("./clientEight.jpg").default,
  clientNine: require("./clientNine.gif").default,
  client10: require("./clinetTen.png").default,
  client11: require("./clientEleven.png").default,
  client12: require("./clientTwelve.png").default,
  client13: require("./clientThirteen.png").default,
  client14: require("./clientFourteen.png").default,
  client15: require("./client15.png").default,
  client16: require("./client16.jpg").default,
  client17: require("./client17.png").default,
  client18: require("./clinet18.png").default,

  client19: require("./client19.png").default,
  client20: require("./client20.png").default,
  client21: require("./client21.png").default,
  client22: require("./client22.png").default,
  client23: require("./client23.png").default,
  client24: require("./client24.png").default,
  client25: require("./client25.png").default,

  client26: require("./client26.png").default,
  client27: require("./client27.png").default,
  client28: require("./client28.png").default,
  client29: require("./client29.png").default,
  client30: require("./client30.png").default,
  client31: require("./client31.png").default,
  client32: require("./client32.png").default,
  client33: require("./client33.png").default,
  client34: require("./client35.png").default,

  client35: require("./client35.png").default,
  client36: require("./client36.png").default,
  client38: require("./client38.png").default,
  client39: require("./client39.png").default,
  client40: require("./client40.png").default,
  client41: require("./client41.png").default,
  client42: require("./client42.png").default,
  client43: require("./client43.png").default,
  client44: require("./client44.png").default,
  client45: require("./client45.png").default,
  client46: require("./client46.png").default,
  client47: require("./client47.png").default,
  client48: require("./client48.png").default,
  client49: require('./client49.png').default,
  client50: require('./client50.png').default,
  client51: require('./clinet51.png').default,

  newPlayStore: require("./new-play-store.svg").default,
  newAppStoreX: require('./latest-app-store.png').default,


  callCenter: require('./call-center.svg').default,
  newPC: require('./new-pc.svg').default,
  newWorld: require('./new-world.svg').default,
  newResume: require('./new-resume.svg').default,
  // candidate view profile
  downLoadResumeLogo: require("./download_cv.png").default,
  noAction: require("./no-action.png").default,
};
